import MensajeForm from "./MensajeForm";
import { postData } from "../../Utils/Http/api";

const MensajeAdd = () => (
  <MensajeForm
    titulo="Agregar Mensaje"
    descripcion="Define un texto de WhatsApp reutilizable para contactar a los sujetos."
    valoresIniciales={{ tipoMensaje: "", texto: "" }}
    onGuardar={(datos) => postData("/MensajeAlta", datos)}
    mensajeExito="¡Mensaje agregado exitosamente!"
  />
);

export default MensajeAdd;
